import './Kontakt.css'
import { Helmet } from 'react-helmet-async';

function Kontakt() {
    return (
        <>
            <Helmet>
                <title>Kontakt za prodaju | Projekt Sarajevska</title>
                <meta
                    name="description"
                    content="Kontakt za prodaju stanova i dodatne informacije o investitoru projekta Sarajevska u Zagrebu."
                />
                <link rel="canonical" href="https://projekt-sarajevska.hr/kontakt/" />
            </Helmet>

            <div style={{paddingTop: "5rem"}}>
                <div className="big-container-contact font-tiskani">
                    <div className="centered-container font-tiskani-kontakt padding-15 contact-container">
                        <div className="font-italic padding-down font-large">
                            Kontakt za prodaju
                        </div>
                        <div className="padding-down">
                            091 6163 435
                        </div>
                        <div className="padding-down center-div">
                            Putem poziva, isključivo radnim danom od 9:00 do 17:00, ili putem e-maila.
                        </div>
                        <div className="padding-down">
                            prodaja.sarajevska@gmail.com
                        </div>
                    </div>
                </div>

                <div className="centered-container">
                    <div className="big-container-contact font-tiskani">
                        <div className="side-by-side">
                            <div className="font-tiskani-kontakt padding-15 contact-container">
                                <h1 className="font-italic padding-down font-large" style={{marginBottom: '20px'}}>
                                    Informacije o investitoru
                                </h1>
                                <div className="padding-down">PROJEKT SARAJEVSKA d.o.o.</div>
                                <div className="padding-down">Sjedište: Ulica Pavla Štoosa 27, 10 000 Zagreb, Hrvatska</div>
                                <div className="padding-down">Ured: Almeria centar, Ulica Grada Vukovara 284, ulaz D / 7. kat, 10 000 Zagreb, Hrvatska</div>
                                <div className="padding-down">OIB:24021176847</div>
                                <div className="padding-down">MBS:081387187</div>
                                <div className="padding-down">EUID:HRSR.081387187</div>
                                <div className="padding-down">Temeljni kapital 3000,00 € uplaćen u cijelosti.</div>
                                <div className="padding-down">Osnivači / članovi društva:</div>
                                <ul>
                                    <li className="padding-down">
                                        Krunoslav Juroš, OIB: 15777113171
                                        Zagreb, Ulica Pavla Štoosa 27 - član društva, direktor
                                    </li>
                                    <li className="padding-down">
                                        Marko Šteko, OIB: 36855254748
                                        Zagreb, Ulica Stjepana Babonića 108 - član društva, prokurist
                                    </li>
                                    <li className="padding-down">
                                        Nenad Pavković, OIB: 53491082610
                                        Zagreb, Bukovački vijenac 17 - član društva
                                    </li>
                                </ul>
                                <div className="padding-down">Transakcijski računi:</div>
                                <ul>
                                    <li>IBAN: HR5323600001102944900 Zagrebačka banka d.d.</li>
                                    <li>IBAN: HR7523600001503480396 Zagrebačka banka d.d.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Kontakt;